<template>
	<div>
        <!-- Info Modal -->
        <div :id="modal_id" :aria-labelledby="modal_id + '-title'" class="uk-flex-top alert-modal" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" aria-label="Close" uk-close></button>
                <div class="uk-modal-header">
                    <h2 :id="modal_id + '-title'">{{ alert_title }}</h2>
                </div>
                <div class="uk-modal-body uk-overflow-auto" v-html="alert_copy">
                </div>
                <div class="bb-footer-buttons">
                    <div class="uk-flex uk-flex-middle">
                        <button @click.prevent="onCancel">Cancel</button>
                        <button @click.prevent="onAgree" class="blue">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name : "info-modal",
		components: {},
        props: {
            modal_id : {
                type : String,
                default : ""
            },
            alert_copy : {
                type : String,
                default : ""
            },
            alert_title : {
                type : String,
                default : ""
            }
        },
        methods : {
            /**
             * ui kit close modal call
             * @return {[type]} [description]
             */
            closeModal(){
                //eslint-disable-next-line
                UIkit.modal(document.getElementById(this.modal_id)).hide();
            },
            /**
             * user clicked the cancel button. close modal
             * @return {[type]} [description]
             */
            onCancel(){
                this.closeModal();
                this.$emit('cancel');
            },
            /**
             * use clicked yes, close modal
             * let parent component user agrees
             * @return {[type]} [description]
             */
            onAgree(){
                this.closeModal();
                this.$emit('agree');
            }
        }
	}
</script>